import { computed, inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { tapResponse } from '@ngrx/operators';

import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';
import { pipe, debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs';
import { UtilsService } from 'src/app/modules/shared/services/utils.service';
import { Router } from '@angular/router';
import { GetHesitantDetailsPayload } from 'src/app/modules/shared/models/beneficiary.models';
import { EncDecService } from 'src/app/modules/shared/services/encryption-decryption.service';
import { DataService } from '../../shared/services';
import { AppConfig } from '../../shared/models/common.model';

type CommonState = {
  appConfigError: Error | boolean;
  appConfigData: AppConfig;
};
const initialState: CommonState = {
  appConfigError: null,
  appConfigData: null,
};

export const CommonStoreData = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(
    (
      store,
      router = inject(Router),
      encDecService = inject(EncDecService),
      dataService = inject(DataService),
      utils = inject(UtilsService)
    ) => ({
      getAllConfigs: rxMethod<void>(
        pipe(
          debounceTime(300),
          distinctUntilChanged(),
          switchMap(() => {
            return dataService.getAllConfigs().pipe(
              tapResponse({
                next: (res: AppConfig) => {
                  //   res.hesitant_access = true;
                  patchState(store, {
                    appConfigData: res,
                    appConfigError: null,
                  });
                },
                error: (err: Error) => {
                  patchState(store, {
                    appConfigError: err,
                    appConfigData: null,
                  });
                },
              })
            );
          })
        )
      ),
    })
  )
);
